var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.getActiveGiftCard.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "gap": "12px"
    }
  }, [_c('v-text-field', {
    staticClass: "font-weight-bold",
    attrs: {
      "label": "Card Code",
      "prepend-inner-icon": "mdi-magnify",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "autofocus": "",
      "hide-details": ""
    },
    model: {
      value: _vm.cardCode,
      callback: function ($$v) {
        _vm.cardCode = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "cardCode"
    }
  }), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "height": "40",
      "loading": _vm.loading,
      "disabled": !_vm.cardCode
    }
  }, [_vm._v("Search")])], 1)])], 1), !_vm.giftCard ? _c('v-card', {
    staticClass: "mt-6 px-6 py-10 text-center"
  }, [_c('v-avatar', {
    staticClass: "mb-4",
    attrs: {
      "color": "grey lighten-3",
      "size": "56"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("mdi-wallet-giftcard")])], 1), _c('div', {
    staticClass: "text-h6 font-weight-bold"
  }, [_vm._v("Check a gift card")]), _c('div', {
    staticClass: "text-body-2 grey--text text--darken-1 mt-2 mx-auto",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_vm._v(" Enter a card code to see its balance, status and details. ")])], 1) : [_c('v-card', {
    staticClass: "mt-6 pa-4"
  }, [_c('div', {
    staticClass: "d-flex align-center flex-wrap",
    staticStyle: {
      "gap": "12px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "d-flex align-center flex-wrap",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('span', {
    staticClass: "text-h6 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.humanize(_vm.giftCard.type)))]), _c('v-chip', {
    staticClass: "font-weight-bold",
    attrs: {
      "small": "",
      "color": _vm.statusChip.color,
      "text-color": _vm.statusChip.text
    }
  }, [_vm._v(" " + _vm._s(_vm.humanize(_vm.giftCard.status)) + " ")]), _vm.isFullyUsed ? _c('v-chip', {
    staticClass: "font-weight-bold",
    attrs: {
      "small": "",
      "color": _vm.defaultChip.color,
      "text-color": _vm.defaultChip.text
    }
  }, [_vm._v(" Fully Used ")]) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex align-center mt-1"
  }, [_c('span', {
    staticClass: "grey--text text--darken-1 mr-2"
  }, [_vm._v("Code:")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.giftCard.code))]), _c('v-tooltip', {
    attrs: {
      "top": "",
      "open-delay": 10,
      "close-delay": 5
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-icon', _vm._g(_vm._b({
          staticClass: "ml-2",
          attrs: {
            "color": "mango-red",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.copyToClipboard(_vm.giftCard.code);
            }
          }
        }, 'v-icon', attrs, false), on), [_vm._v(" mdi-content-copy ")])];
      }
    }])
  }, [_c('span', [_vm._v("Copy")])])], 1)]), _c('v-spacer'), _c('GiftCardPdf', {
    attrs: {
      "disabled": _vm.giftCard.status !== 'completed',
      "tooltip-message": "PDF access is not allowed for gift cards that are not completed.",
      "giftCardCode": _vm.giftCard.code
    }
  })], 1)]), _c('v-row', {
    staticClass: "mt-1"
  }, _vm._l(_vm.summaryTiles, function (tile) {
    return _c('v-col', {
      key: tile.label,
      attrs: {
        "cols": "12",
        "sm": "4"
      }
    }, [_c('v-card', {
      staticClass: "fill-height px-4 py-3"
    }, [_c('div', {
      staticClass: "text-subtitle-2 grey--text text--darken-1"
    }, [_vm._v(_vm._s(tile.label))]), _c('div', {
      staticClass: "text-h5 font-weight-bold my-1"
    }, [_vm._v(_vm._s(tile.value))]), tile.caption ? _c('div', {
      staticClass: "text-caption grey--text text--darken-1"
    }, [_vm._v(_vm._s(tile.caption))]) : _vm._e()])], 1);
  }), 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('v-card', {
    staticClass: "fill-height pa-4"
  }, [_c('div', {
    staticClass: "text-h6 font-weight-bold mb-2"
  }, [_vm._v("Details")]), _c('div', {
    staticClass: "detail-row"
  }, [_c('span', {
    staticClass: "detail-label"
  }, [_vm._v("Code")]), _c('span', [_vm._v(_vm._s(_vm.giftCard.code))])]), _c('div', {
    staticClass: "detail-row"
  }, [_c('span', {
    staticClass: "detail-label"
  }, [_vm._v("Status")]), _c('span', [_vm._v(_vm._s(_vm.humanize(_vm.giftCard.status)))])]), _c('div', {
    staticClass: "detail-row"
  }, [_c('span', {
    staticClass: "detail-label"
  }, [_vm._v("Type")]), _c('span', [_vm._v(_vm._s(_vm.humanize(_vm.giftCard.type)))])]), _c('div', {
    staticClass: "detail-row"
  }, [_c('span', {
    staticClass: "detail-label"
  }, [_vm._v("Description")]), _c('span', {
    staticClass: "pre-line"
  }, [_vm._v(_vm._s(_vm.giftCard.internalDescription || "—"))])]), _c('div', {
    staticClass: "detail-row"
  }, [_c('span', {
    staticClass: "detail-label"
  }, [_vm._v("Referenced Orders")]), _c('span', [_vm._v(_vm._s(_vm.giftCard.internalReferencedOrderNumbers || "—"))])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('v-card', {
    staticClass: "fill-height pa-4"
  }, [_c('div', {
    staticClass: "text-h6 font-weight-bold mb-2"
  }, [_vm._v("History")]), _vm._l(_vm.historyDates, function (row) {
    return _c('div', {
      key: row.label,
      staticClass: "detail-row"
    }, [_c('span', {
      staticClass: "detail-label"
    }, [_vm._v(_vm._s(row.label))]), row.date ? _c('dateTimeField', {
      attrs: {
        "date": row.date,
        "type": "dateTime"
      }
    }) : _c('span', [_vm._v("—")])], 1);
  }), _vm._l(_vm.historyUsers, function (row) {
    var _row$user$fullName;
    return _c('div', {
      key: row.label,
      staticClass: "detail-row"
    }, [_c('span', {
      staticClass: "detail-label"
    }, [_vm._v(_vm._s(row.label))]), row.user ? _c('div', [_c('div', [_vm._v(_vm._s((_row$user$fullName = row.user.fullName) !== null && _row$user$fullName !== void 0 ? _row$user$fullName : row.user.name))]), row.user.email ? _c('div', {
      staticClass: "text-caption grey--text text--darken-1"
    }, [_vm._v(_vm._s(row.user.email))]) : _vm._e()]) : _c('span', [_vm._v("—")])]);
  })], 2)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('v-card', {
    staticClass: "fill-height pa-4"
  }, [_c('div', {
    staticClass: "text-h6 font-weight-bold mb-2"
  }, [_vm._v("Card Content")]), _c('div', {
    staticClass: "detail-row"
  }, [_c('span', {
    staticClass: "detail-label"
  }, [_vm._v("Title Line 1")]), _c('span', [_vm._v(_vm._s(_vm.giftCard.title1 || "—"))])]), _c('div', {
    staticClass: "detail-row"
  }, [_c('span', {
    staticClass: "detail-label"
  }, [_vm._v("Title Line 2")]), _c('span', [_vm._v(_vm._s(_vm.giftCard.title2 || "—"))])]), _c('div', {
    staticClass: "detail-row"
  }, [_c('span', {
    staticClass: "detail-label"
  }, [_vm._v("Message")]), _c('span', {
    staticClass: "pre-line"
  }, [_vm._v(_vm._s(_vm.giftCard.message || "—"))])])])], 1)], 1)]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }